export enum ClientsAlerts {
    USER_ALREDY_EXISTS = "Użytkownik o podanym adresie email już istniej",
    REGISTER_SUCCESS = "Rejestracja przebiegła pomyślnie",
    CHOSE_ORDER_TYPE = "wybierz typ zamówienia"
}